import classNames from 'classnames';

import { Icon } from './icon';
import { DoneAllIcon } from './icons/done_all';
import { CheckIndeterminateSmallIcon } from './icons/check_indeterminate_small';

interface Props {
  value: string;
  checked?: boolean;
  indeterminate?: boolean;
  name?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: React.ReactNode;
}

export const CheckBox: React.FC<Props> = ({
  name,
  value,
  checked,
  indeterminate,
  onChange,
  label,
}) => {
  return (
    <label className='check-box'>
      <input
        name={name}
        type='checkbox'
        value={value}
        checked={checked}
        onChange={onChange}
        readOnly={!onChange}
      />

      <span
        className={classNames('check-box__input', { checked, indeterminate })}
      >
        {indeterminate ? (
          <Icon id='indeterminate' icon={CheckIndeterminateSmallIcon} />
        ) : (
          checked && <Icon id='check' icon={DoneAllIcon} />
        )}
      </span>

      {label && <span>{label}</span>}
    </label>
  );
};
